import { BlenderOutlineIcon } from './BlenderOutlineIcon';

/**
 * author: Google
 * id C8C79C9B-59FC-417E-9516-E5351594A994
 * name blender-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/blender-outline.svg
 * tags
 * - Home Automation 
 * - Food / Drink 
 */
export const FoodProcessorOutlineIcon = BlenderOutlineIcon;
export default FoodProcessorOutlineIcon